import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Request from './utils/serve/request';
import watermark from './utils/util/watermark'
import i18n from './utils/lang/i18n'
import '@/assets/css/element-variables.scss'
import {permission} from './utils/util/permission'

Vue.prototype.$watermark = watermark

Vue.directive('permission', permission)
Vue.use(ElementUI);
Vue.prototype.request = Request;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
